module.exports = __webpack_public_path__ + "333af5a78e6d46326e416740a8c98349.svg";